import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Input } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * 顧客名のフォームのベースです。
 * NOTE: Chakra の Text は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const NameFormBase: FC<Props> = ({ register }) => (
  <Input
    id="name"
    type="text"
    {...register('name', {
      required: '必須項目です。',
      maxLength: {
        value: 100,
        message: '顧客名は 100 文字以内にする必要があります。',
      },
    })}
  />
);
